var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGedFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 960",
    style: {
      enableBackground: "new 0 0 960 960"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#33B98C;}\n\t.st1{fill:#F2F2F2;}\n\t.st2{fill:#FBB03B;}\n\t.st3{fill:#F7931E;}\n\t.st4{fill:#F15A24;}\n\t.st5{fill:#C1272D;}\n\t.st6{fill:#135468;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#D1B07C;}\n\t.st9{fill:#A67C52;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M621.9,813.4H146.3V146.6h475.5c16.3,0,29.5,13.2,29.5,29.5v607.8C651.3,800.2,638.1,813.4,621.9,813.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.8,457.9H310.2c-8.8,0-16-7.2-16-16v-146c0-8.8,7.2-16,16-16h248.6c8.8,0,16,7.2,16,16v146    C574.8,450.7,567.7,457.9,558.8,457.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M674.5,305h-23.2V194.4h23.2c7.9,0,14.4,6.4,14.4,14.4v81.8C688.9,298.5,682.5,305,674.5,305z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M674.5,429.1h-23.2V318.6h23.2c7.9,0,14.4,6.4,14.4,14.4v81.8C688.9,422.7,682.5,429.1,674.5,429.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M674.5,555.2h-23.2V444.6h23.2c7.9,0,14.4,6.4,14.4,14.4v81.8C688.9,548.8,682.5,555.2,674.5,555.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M674.5,683.1h-23.2V572.5h23.2c7.9,0,14.4,6.4,14.4,14.4v81.8C688.9,676.7,682.5,683.1,674.5,683.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.3,
    y: 146.6,
    className: "st6",
    width: 69.3,
    height: 666.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.6,
    y: 323.5,
    className: "st6",
    width: 183.3,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.6,
    y: 358.6,
    className: "st6",
    width: 183.3,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.6,
    y: 393.6,
    className: "st6",
    width: 183.3,
    height: 15.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -3.676774e-03 3.676774e-03 1 -2.4737 2.4287)",
    className: "st7",
    cx: 659.3,
    cy: 674,
    rx: 110.2,
    ry: 110.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -3.676774e-03 3.676774e-03 1 -2.4737 2.4287)",
    className: "st8",
    cx: 659.3,
    cy: 674,
    rx: 82,
    ry: 82
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M593.5,688.5c-0.2-45.3,36.4-82.1,81.7-82.3c14.5-0.1,28.2,3.7,40.1,10.3c-14.7-13.7-34.5-22.1-56.2-22    c-45.3,0.2-81.8,37-81.7,82.3c0.1,30.7,17.1,57.4,42.2,71.4C603.6,733.2,593.6,712,593.5,688.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M799.8,655.1l-39.6,0.1c-7.7,0-13.8,6.3-13.8,13.9v2.5c0,7.7,6.3,13.8,13.9,13.8l39.6-0.1    c7.7,0,13.8-6.3,13.8-13.9v-2.5C813.6,661.2,807.4,655.1,799.8,655.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGedFileIcon);
export default __webpack_public_path__ + "static/media/ged-file-icon.c5b65fd278725846b1951f5da746b644.svg";
export { ForwardRef as ReactComponent };